import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import classnames from "classnames";
import { Box } from "@material-ui/core";


//icons


// styles
import useStyles from "./styles";

// components
import Header from "../Header";
import Sidebar from "../Sidebar";

// pages
import Dashboard from "../../Pages/Dashboard";
import Typography from "../../Pages/Typography";
import Notifications from "../../Pages/Notifications";
import Maps from "../../Pages/Maps";
import Tables from "../../Pages/Tables";
import Icons from "../../Pages/Icons";

import Experiments from "../../Pages/Experiments/Experiments";

import Textmergerpage from "../../Pages/TextMergerPage/Textmergerpage";
import urlopenerpage from "../../Pages/UrlOpenerPage/urlopenerpage";
import sellersjsonpage from "../../Pages/SellersJsonPage/sellersjsonpage";
import bidrequestpage from "../../Pages/BidRequestPage/bidrequestpage";
import SellersJsonValidator from "../SellersJsonValidator/SellersJsonValidator";
import ApprovedBundlesTable from "../../Pages/ApprovedBundles/approvedbundles";
import sqta from "../../Pages/Sqta/sqta";
// context
import { useLayoutState } from "../../Context/LayoutContext";
import CTVAnalyser from "../CTVAnalyser/CTVAnalyser";
import AppAnalyserBeta from "../AppAnalyser20/AppAnalyserBeta";

function Layout(props) {
  var classes = useStyles();

  // global
  var layoutState = useLayoutState();

  return (
    <div className={classes.root}>
        <>
          <Header history={props.history} />
          <Sidebar />
          <div
            className={classnames(classes.content, {
              [classes.contentShift]: layoutState.isSidebarOpened,
            })}
          >
            <div className={classes.fakeToolbar} />
            <Switch>
              <Route path="/app/appanalyser" component={Dashboard} />
              <Route path="/app/appanalyser2" component={AppAnalyserBeta} />
              <Route path="/app/websiteanalyser" component={Typography} />
              <Route path="/app/adrenderers" component={Tables} />
              <Route path="/app/miscellaneous" component={Notifications} />
              <Route path="/app/keywordchecker" component={Icons} />
              <Route path="/app/ctvanalyser" component={CTVAnalyser} />
              <Route path="/app/textmerger" component={Textmergerpage} />
              <Route path="/app/urlopener" component={urlopenerpage} />
              <Route path="/app/sellersjsonexporter" component={sellersjsonpage} />
              <Route path="/app/bidrequestsanalyser" component={bidrequestpage} />
              <Route path="/app/experiments" component={Experiments} />
              <Route path="/app/sellerjsonvalidator" component={SellersJsonValidator}></Route>
              <Route path="/app/approved" component={Maps}></Route>
              <Route path="/app/approvedbundles" component={ApprovedBundlesTable}></Route>
              <Route path="/app/sqta" component={sqta}></Route>
            </Switch>
            <Box
              mt={5}
              width={"100%"}
              display={"flex"}
              alignItems={"center"}
              justifyContent="space-between"
            >
              <div>
<h6>Copyright Damian Chymkowski 2023-2024</h6>
              </div>
            </Box>
          </div>
        </>
    </div>
  );
}

export default withRouter(Layout);
